import React from "react";
import ToolTip from "../../HOC/ToolTip";

const Input = React.forwardRef((props, ref) => (
	<React.Fragment>
		{(props.labelText || props.label) && (
			<label className="form__label">
				{props.labelText || props.label}
				{props.requiredStar ? (
					<span
						style={{ color: "#ff0505", paddingLeft: "1px", opacity: "0.7" }}
					>
						*
					</span>
				) : (
					""
				)}

				{props.tooltipText && (
					<ToolTip adjustParentStyle={true} width={props.tooltipWidth || 170}>
						{props.tooltipText}
					</ToolTip>
				)}
			</label>
		)}
		<div
			style={{ position: "relative", width: props.width ? props.width : "" }}
			className="form__wrapper"
		>
			<input
				className="form__input"
				type={props.type}
				id={props.id || ""}
				spellCheck={props.spellCheck === false ? false : true}
				value={props.value}
				min={props.min}
				max={props.max}
				maxLength={props.maxLength ? props.maxLength : 64}
				minLength={props.minLength}
				name={props.name}
				placeholder={props.placeholder}
				onChange={props.changeInput || props.inputChange || props.onChange}
				required={props.required}
				disabled={props.loading || props.disabled}
				readOnly={props.disabled}
				onFocus={props.onFocus}
				autoComplete={props.autoComplete}
				{...(props.autoFocus && { autoFocus: props.autoFocus })}
				{...(props.inputKeyPress && { onKeyPress: props.inputKeyPress })}
				{...(props.onKeyPress && { onKeyPress: props.onKeyPress })}
				{...(props.onKeyDown && { onKeyDown: props.onKeyDown })}
				{...(props.onKeyUp && { onKeyUp: props.onKeyUp })}
				{...(props.pattern && { pattern: props.pattern })}
				{...(props.inputMode && { inputMode: props.inputMode })}
				{...(props.inputBlur && { onBlur: props.inputBlur })}
				{...(props.onBlur && { onBlur: props.onBlur })}
				{...(props.onFocus && { onFocus: props.onFocus })}
				{...(props.defaultValue && { defaultValue: props.defaultValue })}
				style={{
					padding:
						props.type !== "color"
							? props.size === "tiny"
								? "0 6px"
								: props.size === "small"
								? "6px 12px"
								: "9px 12px"
							: "0px",
					marginBottom: props.withMargin ? "20px" : "",
					marginTop: "0px",
					paddingLeft: props.withIcon
						? "35px"
						: props.currency
						? `${props.currency.props.children.length * 8 + 20}px`
						: props.customInput
						? "110px"
						: props.paddingLeft
						? props.paddingLeft
						: "",
					border: props.errorText
						? "1px solid red"
						: props.successText
						? "1px solid #5CB85C"
						: props.warningText
						? "1px solid #ff9966"
						: "",
					borderRadius: props.borderRadius ? props.borderRadius : "",
				}}
				ref={ref}
			/>
			{props.icon && (
				<span
					className="input-icon flex"
					style={{
						position: "absolute",
						transform: "translateY(-50%)",
						top: "50%",
						paddingLeft: "10px",
						right: props.rightIcon ? "10px" : " ",
						cursor: props.clickable ? "pointer" : "",
					}}
					onClick={props.iconClick}
				>
					{props.icon}
				</span>
			)}
			{props.currency && (
				<span
					className="input-icon flex"
					style={{
						position: "absolute",
						transform: "translateY(-50%)",
						top: "50%",
						paddingLeft: "10px",
					}}
				>
					{props.currency}
				</span>
			)}
			{props.withSearchIcon && (
				<span
					className="input-icon flex"
					style={{
						position: "absolute",
						transform: "translateY(-50%)",
						top: "50%",
						paddingLeft: "10px",
					}}
				>
					<img src="Images/search-icon.svg" alt="" width="14" height="14" />
				</span>
			)}
			{props.passwordIcon && (
				<span
					className="input-icon flex"
					onClick={props.toggleInputType}
					style={{
						position: "absolute",
						transform: "translateY(-50%)",
						top: "50%",
						right: "10px",
						paddingRight: "10px",
						cursor: "pointer",
					}}
				>
					{props.passwordIcon}
				</span>
			)}
			{props.errorText && (
				<span
					style={{
						position: "absolute",
						fontSize: "11px",
						color: "red",
						bottom: props.currency
							? props.errorPosition
								? props.errorPosition
								: "-17px"
							: "-17px",
					}}
				>
					{props.errorText}
				</span>
			)}
			{props.warningText && (
				<span
					style={{
						position: "absolute",
						fontSize: "11px",
						color: "#ff9966",
						bottom: "-17px",
					}}
				>
					{props.warningText}
				</span>
			)}
			{props.successText && (
				<span
					style={{
						position: "absolute",
						fontSize: "11px",
						color: "#5CB85C",
						bottom: props.currency ? "-17px" : "-17px",
					}}
				>
					{props.successText}
				</span>
			)}
			{props.loading && (
				<span
					className="loading-circle"
					style={{
						position: "absolute",
						fontSize: "11px",
						color: "#5CB85C",
						transform: "translateY(-50%)",
						top:
							props.size === "small" ? "calc(50% - 7px)" : "calc(50% - 10px)",
						opacity: 0.6,
						right: "10px",
						height: props.size === "small" ? "14px" : "",
						width: props.size === "small" ? "14px" : "",
					}}
				></span>
			)}
			{props.countLength && props.maxLength && (
				<span
					style={{
						position: "absolute",
						fontSize: "9px",
						color: "#5e7079",
						bottom: "-14px",
						right: "0px",
					}}
				>
					{props.value.length} / {props.maxLength}
				</span>
			)}
		</div>
	</React.Fragment>
));

export default Input;
